import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app';
import i18n from './i18n';
import { UrlLocaleProvider } from './i18n/url-locale';
import { localeFromPathname } from '@shared/locales';
import './styles/index.css';

// The URL encodes the language of the prerendered HTML. Switch i18next to that
// locale *before* the first client render so hydration matches; the basename
// keeps in-page links inside the same prefix.
const { locale, prefix } = localeFromPathname(window.location.pathname);
void i18n.changeLanguage(locale);

const root = document.getElementById('root')!;
const app = (
  <StrictMode>
    <UrlLocaleProvider locale={locale}>
      <BrowserRouter basename={prefix || undefined}>
        <App />
      </BrowserRouter>
    </UrlLocaleProvider>
  </StrictMode>
);

if (root.hasChildNodes()) {
  hydrateRoot(root, app);
} else {
  createRoot(root).render(app);
}
